import {Grid, WithStyles, withStyles} from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'
import {Trans} from 'react-i18next'
import messages from '../../../../../../../../assets/messages'
import {styles} from '../styles'
import {Currency} from '../../../../../../../../graphql/types'
import {getFormattedAmount} from '../../../../../../../../common/utils'

type AdditionalDepositNeededBadgeProps = WithStyles<typeof styles> & {
  additionalDeposit: number;
  currency: Currency | null;
}

const _AdditionalDepositNeededBadge = (props: AdditionalDepositNeededBadgeProps) => {
  const {classes, additionalDeposit, currency} = props

  return (
    <Grid item className={classNames(classes.pending, classes.isDemoArchived)}>
      <Typography variant='caption' className={classes.pendingText}>
        <Trans
          {...messages.additionalDepositNeeded}
          values={{amount: getFormattedAmount({currency, amount: additionalDeposit})}}
        />
      </Typography>
    </Grid>
  )
}

export const AdditionalDepositNeededBadge = withStyles(styles, {withTheme: true})(_AdditionalDepositNeededBadge)
